// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { MvpApiListModelsData, MvpApiListModelsResponses, MvpApiCreateModelData, MvpApiCreateModelResponses, MvpApiDeleteModelData, MvpApiDeleteModelResponses, MvpApiGetModelData, MvpApiGetModelResponses, MvpApiUpdateModelData, MvpApiUpdateModelResponses, MvpApiListAllEmbeddingsData, MvpApiListAllEmbeddingsResponses, MvpApiCreateEmbeddingData, MvpApiCreateEmbeddingResponses, MvpApiDeleteEmbeddingData, MvpApiDeleteEmbeddingResponses, MvpApiGetEmbeddingData, MvpApiGetEmbeddingResponses, MvpApiUpdateEmbeddingData, MvpApiUpdateEmbeddingResponses, MvpApiListEmbeddingsData, MvpApiListEmbeddingsResponses, MvpApiSearchEmbeddingsData, MvpApiSearchEmbeddingsResponses, MvpApiTritonProxyData, MvpApiTritonProxyResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List Models
 */
export const mvpApiListModels = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListModelsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListModelsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/models',
        ...options
    });
};

/**
 * Create Model
 */
export const mvpApiCreateModel = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateModelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateModelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/models',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Model
 */
export const mvpApiDeleteModel = <ThrowOnError extends boolean = false>(options: Options<MvpApiDeleteModelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<MvpApiDeleteModelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/models/{model_id}',
        ...options
    });
};

/**
 * Get Model
 */
export const mvpApiGetModel = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetModelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetModelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/models/{model_id}',
        ...options
    });
};

/**
 * Update Model
 */
export const mvpApiUpdateModel = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateModelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdateModelResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/models/{model_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List All Embeddings
 */
export const mvpApiListAllEmbeddings = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListAllEmbeddingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListAllEmbeddingsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings',
        ...options
    });
};

/**
 * Create Embedding
 */
export const mvpApiCreateEmbedding = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateEmbeddingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateEmbeddingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Embedding
 */
export const mvpApiDeleteEmbedding = <ThrowOnError extends boolean = false>(options: Options<MvpApiDeleteEmbeddingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<MvpApiDeleteEmbeddingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings/{embedding_id}',
        ...options
    });
};

/**
 * Get Embedding
 */
export const mvpApiGetEmbedding = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetEmbeddingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetEmbeddingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings/{embedding_id}',
        ...options
    });
};

/**
 * Update Embedding
 */
export const mvpApiUpdateEmbedding = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateEmbeddingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdateEmbeddingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings/{embedding_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Embeddings
 */
export const mvpApiListEmbeddings = <ThrowOnError extends boolean = false>(options: Options<MvpApiListEmbeddingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiListEmbeddingsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings/filter',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search Embeddings
 */
export const mvpApiSearchEmbeddings = <ThrowOnError extends boolean = false>(options: Options<MvpApiSearchEmbeddingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiSearchEmbeddingsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/embeddings/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Triton Proxy
 * Generic proxy for product embedding image ensemble v5
 */
export const mvpApiTritonProxy = <ThrowOnError extends boolean = false>(options: Options<MvpApiTritonProxyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiTritonProxyResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/triton/create-embedding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};